import { Box, Button, Typography } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import DescriptionTwoToneIcon from "@mui/icons-material/DescriptionTwoTone";

export function RetryDocumentRetrieval({
  onRetryClick,
}: {
  onRetryClick: () => Promise<void> | (()=> void);
}) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          p: 4,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 3,
          maxWidth: 500,
          mx: "auto",
        }}
      >
        <DescriptionTwoToneIcon
          sx={{
            fontSize: 80,
          }}
        />
        <Typography
          variant="h5"
          color="text.primary"
          align="center"
          fontWeight="medium"
        >
          Failed to retrieve the document
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{
            mb: 1,
          }}
        >
          Please retry retrieving.
        </Typography>
        <Button
          onClick={onRetryClick}
          variant="contained"
          color="success"
          size="large"
          endIcon={<ReplayIcon />}
          sx={{
            px: 4,
            py: 1,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: "medium",
          }}
        >
          Retry
        </Button>
      </Box>
    </div>
  );
}
